module.exports = __webpack_public_path__ + "media/images/google_play-bf646b70d90f507f84a65590dc3d454c.svg";